var PhoneVerificationStrategy = (function (_, $, PromiseUtil, PaymentStrategy) {

    var PhoneVerificationStrategy = function (attrs) {
        PaymentStrategy.apply(this, arguments);

        _.extend(this, {
            Validator: null,
            Braintree: null
        }, attrs);
    };

    PhoneVerificationStrategy.prototype = _.extend(window.app.jsUtils.createObjectWithProto(PaymentStrategy.prototype), {
        constructor: PhoneVerificationStrategy,

        beforeProcess: function (method) {
            var phoneNumberVerification = this.PhoneNumberVerification;

            var $defer = $.Deferred(), arguments_ = arguments;

            var promise = phoneNumberVerification ? phoneNumberVerification.verify(method) : PromiseUtil.resolved();
            promise.done(function() {
                $defer.resolve.apply($defer, arguments_);
            });

            return $defer.promise();
        }
    });

    return PhoneVerificationStrategy;
})(_, $, PromiseUtil, PaymentStrategy);
